"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.takingSubmitComment = exports.takingReminderSetCommand = exports.takingSubmitCommand = exports.takingQuestionAddChoiceCommand = exports.takingStartCommand = exports.TakingCommands = void 0;
const Command_1 = require("./Command");
var TakingCommands;
(function (TakingCommands) {
    TakingCommands["Start"] = "survey/taking/start";
    TakingCommands["Submit"] = "survey/taking/submit";
    TakingCommands["SubmitComment"] = "survey/taking/comment/submit";
    TakingCommands["QuestionAddChoice"] = "survey/taking/question/choice/add";
    TakingCommands["SetReminder"] = "survey/taking/reminder/set";
})(TakingCommands = exports.TakingCommands || (exports.TakingCommands = {}));
function takingStartCommand(surveyId, retake) {
    const data = { surveyId, retake, command: TakingCommands.Start };
    return new Command_1.Command(data);
}
exports.takingStartCommand = takingStartCommand;
function takingQuestionAddChoiceCommand(surveyId, questionId) {
    const data = {
        surveyId,
        questionId,
        command: TakingCommands.QuestionAddChoice,
    };
    return new Command_1.Command(data);
}
exports.takingQuestionAddChoiceCommand = takingQuestionAddChoiceCommand;
function takingSubmitCommand(surveyId, questionIndexId, questionIds, direction = "next") {
    const data = {
        command: TakingCommands.Submit,
        surveyId,
        questionIndexId,
        questionIds,
        direction,
    };
    return new Command_1.Command(data);
}
exports.takingSubmitCommand = takingSubmitCommand;
function takingReminderSetCommand(surveyId, threadId, messageId) {
    const data = {
        surveyId,
        command: TakingCommands.SetReminder,
        threadId,
        messageId,
    };
    return new Command_1.Command(data);
}
exports.takingReminderSetCommand = takingReminderSetCommand;
function takingSubmitComment(surveyId) {
    const data = {
        command: TakingCommands.SubmitComment,
        surveyId,
    };
    return new Command_1.Command(data);
}
exports.takingSubmitComment = takingSubmitComment;
//# sourceMappingURL=TakingCommands.js.map